import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from '@mui/icons-material/Home';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';

const StyledTab = styled(Tab)(({ theme }) => ({
  '&.MuiTab-root': {
    padding: '0 5px',
    height: 40,
    minHeight: 40,
  },
  '& .MuiTypography-root': {
    color: theme.palette.text.primary,
  },
  '& .MuiSvgIcon-root': {
    color: 'inherit',
  },
  '&&.Mui-selected': {
    color: theme.palette.primary.main,
  },
  '&&.Mui-selected .MuiTypography-root': {
    color: theme.palette.primary.main,
  },
  '&&.Mui-selected .MuiSvgIcon-root': {
    color: theme.palette.primary.main,
  },
}));

export interface TicketTabsPropsT {
  tabs: Record<string, string>;
  tabIndex: number;
  onTabClick: (ticketId: string, route: string) => void;
  onCloseTab: (e: React.MouseEvent, tabLabel: string, ticketId: string) => void;
}

export const TicketTabs: FC<TicketTabsPropsT> = ({ tabs, tabIndex, onTabClick, onCloseTab }) => {
  const tabLabels = Object.keys(tabs);
  const totalTabs = 1 + tabLabels.length;
  const maxValidIndex = totalTabs - 1;
  const validTabIndex = Math.max(0, Math.min(tabIndex, maxValidIndex));

  return (
    <Box sx={{ bgcolor: (theme): string => theme.palette.background.default }}>
      <Tabs value={validTabIndex} sx={{ height: 40, minHeight: 40 }}>
        <StyledTab label={<HomeIcon />} onClick={(): void => onTabClick('', '/tickets')} />
        {tabLabels.map(tabLabel => (
          <StyledTab
            key={tabLabel}
            label={
              <Box display="flex" gap={2} alignItems="center">
                <Typography fontSize={14}>{tabLabel}</Typography>
                <CloseIcon
                  onClick={(e): void => onCloseTab(e, tabLabel, tabs[tabLabel])}
                  data-testid="close-ticket-tab"
                />
              </Box>
            }
            onClick={(): void => onTabClick(tabs[tabLabel], `/tickets/ticket/${tabs[tabLabel]}`)}
          />
        ))}
      </Tabs>
    </Box>
  );
};
